
import Vue from "vue";
import delCom from "@/components/DelDataCom.vue";
import action from "@/components/ActionBarCom.vue";
import addrCom from "@/components/AddrCom.vue";
import dialogCom from "@/components/ModelCom.vue";
import OrderRequestBill from "@/assets/js/Bill/OrderRequestBill";
import Urls from "@/assets/js/Urls";
import HttpUtil from "@/assets/js/HttpUtil";
import pageCom from "@/components/PageCom.vue";
import Utils from "@/assets/js/Utils";
import assetSelectCom from "../ShareComponents/AssetSelectCom.vue";
import uploadPicCom from "@/components/UploadPicComs.vue";
export default Vue.extend({
  components: {
    action,
    addrCom,
    dialogCom,
    delCom,
    pageCom,
    assetSelectCom,
    uploadPicCom,
  },
  data() {
    return {
      assetSearch: null as any,
      items: [] as any[],
      total: 0 as number,
      pageSize: Utils.getDefalutPageSize(),
      currentPage: 1,
      searchStr: null as any,
      dialogTitle: "新增资产",
      form: {
        workOrderTypeSid: "",
        lat: 0,
        lng: 0,
        address: "",
        assetDesc: "",
        serial: "",
        ticketDesc: "",
        reportPics: [] as string[],
      } as any,
      current: null as any,
      orderTypes: [] as any[],
      currentSid: "",
      delUrl: Urls.DeleteAssets,
      currentAsset: {} as any,
    };
  },
  mounted() {
    this.select();
    this.getOrderTypes();
  },
  methods: {
    showAsset() {
      const dialog: any = this.$refs.assetDialog;
      dialog.open(this.assetSearch);
    },
    assetChoosed(val: any) {
      this.form.serial = val.serial;
      this.assetSearch = val.assetName;
      this.currentAsset = val;
      const addr: any = this.$refs.addr;
      addr.init({
        addr: this.currentAsset.address,
        lat: this.currentAsset.lat,
        lng: this.currentAsset.lng,
      });
    },
    opened() {
      setTimeout(() => {
        const addr: any = this.$refs.addr;
        if (!this.current) {
          addr.init(null);
        } else {
          addr.init({
            addr: this.current.address,
            lat: this.current.lat,
            lng: this.current.lng,
          });
        }
      }, 2000);
    },
    closeDialog() {
      const dialog: any = this.$refs.editDialog;
      dialog.hiden();
    },
    async getOrderTypes() {
      const obj = {
        page: 0,
        pageSize: 100,
      };
      var req: any = await HttpUtil.XCHttpPost(Urls.GetOrderTypes, obj, true, false);
      this.orderTypes = req.data;
    },
    async select() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret = await OrderRequestBill.GetOrders(
        content,
        this.currentPage,
        this.pageSize
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    search() {
      this.select();
    },
    currentChange(val: any) {
      this.current = val;
    },
    handleSelectionChange() {
      //
    },
    insert() {
      this.form = {
        workOrderTypeSid: "",
        lat: 0,
        lng: 0,
        address: "",
        assetDesc: "",
        serial: "",
        ticketDesc: "",
        reportPics: "",
      };
      this.form.sid = null;
      const dialog: any = this.$refs.editDialog;
      dialog.show();
    },
    modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.form = this.current;
      const dialog: any = this.$refs.editDialog;
      dialog.show();
      window.setTimeout(() => {
        const picCom: any = this.$refs.uploadPicCom;
        const picArray = JSON.parse(this.form.reportPics);
        picCom.clearPic();
        if (picArray && picArray.length > 0) {
          picArray.forEach((pic: any) => {
            picCom.initPic(pic);
          });
        }
      }, 500);
    },
    del() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.currentSid = this.current.sid;

      const dialog: any = this.$refs.del;
      dialog.show();
    },
    async asyncDev() {
      await HttpUtil.XCHttpPost(Urls.AsyncDeviceAssets, "", true, false);
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.select();
    },
    onSubmit() {
      const addr: any = this.$refs.addr;
      const data: any = addr.getData();
      this.form.address = data.addr;
      this.form.lat = data.lat;
      this.form.lng = data.lng;
      const picCom: any = this.$refs.uploadPicCom;
      const pics = picCom.GetPics();

      this.form.reportPics = "";
      let picArray = [] as string[];
      if (pics && pics.length > 0) {
        pics.forEach((pic: any) => {
          console.log(pic);
          picArray.push(pic.url);
        });
      }
      const picString = JSON.stringify(picArray);
      this.form.reportPics = picString;
      if (this.form.sid) {
        HttpUtil.XCHttpPost(Urls.UpdateOrder, this.form, true, false);
      } else {
        HttpUtil.XCHttpPost(Urls.AddOrder, this.form, true, false);
      }
      this.closeDialog();
      this.select();
    },
  },
});
